export const css = {
    root: '_3o3rqsTr',
    toolbar: 'j1yue9sH',
    iconButton: '_1kQonk5w',
    editorRoot: 'om8KgtdJ',
    selector: '_3HewEwGT',
    linkDialog: '_3PZjPRvW',
    ' _key': 'editor-widget/editor'
};
export default css;
